<template>
  <CustomModal ref="modal" class="invoice-transmission-history-modal" title="Historique">
    <div class="header">
      <div>
        <span class="label">ID PDP</span>
        <span>{{ invoiceTransmission?.providers?.superpdp.providerInvoiceId || "-" }}</span>
      </div>

      <div>
        <span class="label">Statut actuel</span>
        <span class="transmission-status" :style="getTransmissionStatusStyle(invoiceTransmission?.providers.superpdp.status)">
          {{ getTransmissionStatus(invoiceTransmission?.providers.superpdp.status) }}
        </span>
      </div>

    </div>

    <div class="timeline">
      <div v-if="!events.length" class="empty">
        Aucun événement disponible.
      </div>

      <div v-for="event in events" :key="event.id" class="event">
        <div class="dot" :style="getTransmissionStatusDotStyle(event.status_code)"></div>
        <div class="content">
          <div class="top">
            <span class="status">{{ getTransmissionStatus(event.status_code) }}</span>
            <span class="date">{{ formatDate(event.created_at) }}</span>
          </div>
          <div class="code">{{ event.status_code }}</div>
          <div v-if="event.status_text || event.data?.reason" class="text">{{ getEventLabel(event) }}</div>
          <ul v-if="getEventDetails(event).length" class="details">
            <li v-for="(line, index) in getEventDetails(event)" :key="index">{{ line }}</li>
          </ul>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/modals/CustomModal.vue";
import {
  getTransmissionStatus,
  getTransmissionStatusDotStyle,
  getTransmissionStatusStyle
} from "@/invoice-transmission/utils";

export default {
  name: "InvoiceTransmissionHistoryModal",
  components: {
    CustomModal
  },
  data() {
    return {
      invoiceTransmission: undefined,
      events: []
    };
  },
  methods: {
    getTransmissionStatusDotStyle,
    getTransmissionStatusStyle,
    getTransmissionStatus,
    openModal(invoiceTransmission) {
      this.invoiceTransmission = invoiceTransmission;
      this.events = [...(invoiceTransmission?.providers?.superpdp?.events || [])]
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      this.$refs.modal.openModal();
    },
    formatDate(date){
      if(!date){
        return "-";
      }

      return new Date(date).toLocaleString("fr-FR");
    },
    getEventDetails(event) {
      // Motifs détaillés d'un événement (ex. rejet) : details[].reason et contenu des notes, sans répéter data.reason déjà dans le libellé
      const lines = [];

      for (const detail of event?.details || []) {
        if (detail.reason) lines.push(detail.reason);

        for (const note of detail.notes || []) {
          for (const content of note.contents || []) {
            if (content.content) lines.push(content.content);
          }
        }
      }

      return lines.filter((line, index) => line !== event.data?.reason && lines.indexOf(line) === index);
    },
    getEventLabel(event) {
      if (!event) return "-";

      let label = event.status_text || event.status_code;

      if (event.data?.reason) {
        label += ` : ${event.data.reason}`;
      }

      return label;
    }

  }

}
</script>

<style scoped lang="stylus">

.header
  display flex
  justify-content space-between
  gap 20px
  margin-bottom 30px

  > div
    display flex
    flex-direction column

.label
  font-size 11px
  color #777
  margin-bottom 4px

.timeline
  display flex
  flex-direction column
  max-height 420px
  overflow-y auto
  padding-right 8px

.event
  display flex
  gap 15px
  position relative
  padding-bottom 20px

.event:not(:last-child):after
  content ""
  position absolute
  left 7px
  top 18px
  width 2px
  bottom 0
  background #ddd

.dot
  width 16px
  height 16px
  border-radius 50%
  background #1565c0
  flex-shrink 0
  margin-top 3px

.content
  flex 1

.top
  display flex
  justify-content space-between
  align-items center

.status
  font-weight bold

.date
  color #777
  font-size 12px

.code
  font-family monospace
  color #1565c0
  margin-top 4px

.text
  margin-top 6px

.details
  margin 6px 0 0
  padding-left 18px
  font-size 13px
  color #555

.empty
  text-align center
  color #999
  padding 40px

.transmission-status
  display inline-block
  padding 4px 10px
  border-radius 20px
  font-size 12px
  font-weight bold
</style>